import React from 'react'
import { Outlet } from 'react-router-dom'
import DashBoardNavbar from '../DashBoardNavbar/DashBoardNavbar'
import DashBoardFooter from '../DashBoardFooter/DashBoardFooter'
const DashBoardLayout = () => {
  return (
    <>
        <DashBoardNavbar />
        <Outlet/>
        <DashBoardFooter/>
    </>
  )
}

export default DashBoardLayout